if (!customElements.get('begode-photo-slideshow')) {
  customElements.define('begode-photo-slideshow', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const on = (el, type, fn) => el?.addEventListener(type, fn, {signal:this.abort.signal});
      this.slides = [...this.querySelectorAll('[data-photo-slide]')];
      this.track = this.querySelector('[data-photo-track]');
      this.index = 0;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.reduced.matches;
      this.visible = true;
      this.hovered = false;
      this.focused = false;
      this.dataset.count = this.slides.length;
      const controls = this.querySelector('[data-photo-controls]');
      if (controls) controls.hidden = this.slides.length < 2;
      const pause = this.querySelector('[data-photo-pause]');
      if (pause) pause.hidden = this.dataset.autoplay !== 'true' || this.slides.length < 2;
      on(this.querySelector('[data-photo-next]'), 'click', () => this.show(this.index+1));
      on(this.querySelector('[data-photo-prev]'), 'click', () => this.show(this.index-1));
      this.querySelectorAll('[data-photo-jump]').forEach(b => on(b,'click',()=>this.show(Number(b.dataset.photoJump))));
      on(this.querySelector('[data-photo-pause]'),'click',()=>{this.paused=!this.paused;this.paintPause();this.schedule();});
      const area = this.closest('.bh38-card') || this;
      on(area,'pointerenter',e=>{if(e.pointerType==='mouse'){this.hovered=true;this.schedule();}});
      on(area,'pointerleave',()=>{this.hovered=false;this.schedule();});
      on(area,'focusin',()=>{this.focused=true;this.schedule();});
      on(area,'focusout',e=>{this.focused=area.contains(e.relatedTarget);this.schedule();});
      on(area,'pointerdown',e=>{if(e.isPrimary&&e.pointerType!=='mouse')this.start={x:e.clientX,y:e.clientY};});
      on(area,'pointerup',e=>{
        if(!this.start)return;
        const dx=e.clientX-this.start.x,dy=e.clientY-this.start.y;this.start=null;
        if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)*1.3){this.swiped=Date.now()+400;this.show(this.index+(dx<0?1:-1));}
      });
      on(area,'pointercancel',()=>{this.start=null;});
      area.addEventListener('click',e=>{if(Date.now()<this.swiped){e.preventDefault();this.swiped=0;}},{capture:true,signal:this.abort.signal});
      on(this,'keydown',e=>{if(['ArrowLeft','ArrowRight'].includes(e.key)){e.preventDefault();this.show(this.index+(e.key==='ArrowRight'?1:-1));}});
      on(document,'visibilitychange',()=>this.schedule());
      on(this.reduced,'change',()=>{this.paused=this.reduced.matches;this.paintPause();this.schedule();});
      this.visibility=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.schedule();});
      this.visibility.observe(this);
      this.paintPause();this.show(0);
    }
    show(index) {
      if(!this.slides.length)return;
      this.index=(index+this.slides.length)%this.slides.length;
      this.slides.forEach((slide,i)=>{
        slide.classList.toggle('is-active',i===this.index);
        slide.setAttribute('aria-hidden',String(i!==this.index));
        slide.inert=i!==this.index;
      });
      // Preload the next history photograph before its short dissolve transition.
      [this.index,(this.index+1)%this.slides.length].forEach(i=>{
        const img=this.slides[i].querySelector('img[data-bst-src]');
        if(img){img.loading='eager';if(img.dataset.bstSrcset)img.srcset=img.dataset.bstSrcset;img.src=img.dataset.bstSrc;delete img.dataset.bstSrc;delete img.dataset.bstSrcset;}
      });
      this.track.style.transform=`translateX(-${this.index*100}%)`;
      const count=this.querySelector('[data-photo-current]');if(count)count.textContent=this.index+1;
      this.querySelectorAll('[data-photo-jump]').forEach((b,i)=>b.setAttribute('aria-current',String(i===this.index)));
      this.schedule();
    }
    paintPause(){const b=this.querySelector('[data-photo-pause]');if(b){b.textContent=this.paused?'▶':'❚❚';b.setAttribute('aria-pressed',String(this.paused));b.setAttribute('aria-label',this.paused?'Play slideshow':'Pause slideshow');}}
    schedule(){
      clearTimeout(this.timer);
      if(this.dataset.autoplay==='true'&&this.slides.length>1&&!this.paused&&!this.hovered&&!this.focused&&this.visible&&!document.hidden&&!window.Shopify?.designMode)
        this.timer=setTimeout(()=>this.show(this.index+1),(Number(this.dataset.seconds)||6)*1000);
    }
    disconnectedCallback(){clearTimeout(this.timer);this.abort?.abort();this.visibility?.disconnect();}
  });
}
